
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.125 11.11h15.75c.125 0 .188.062.188.187v1.406c0 .125-.063.188-.188.188H4.125c-.125 0-.188-.063-.188-.188v-1.406c0-.125.063-.188.188-.188z","fill":"#000"}})])
          )
        }
      }
    